import { render, staticRenderFns } from "./OsInternalUsersCustomers.vue?vue&type=template&id=281db9da&scoped=true"
import script from "./OsInternalUsersCustomers.vue?vue&type=script&lang=ts"
export * from "./OsInternalUsersCustomers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281db9da",
  null
  
)

export default component.exports